import { IReturnDeclarationDto, IReturnDeclarationDtoPersistence } from '../interfaces';

export class ReturnDeclarationMapper {
  public static toPersistence(dto: IReturnDeclarationDto): IReturnDeclarationDtoPersistence {
    return {
      declaration_id: dto.declarationId,
      return_reason_id: dto.typeId,
      return_delivery_price: Number(dto.returnDeliveryPrice).toString(),
      return_percent: Number(dto.returnOrderExtra).toString(),
      return_declaration_price: Number(dto.returnDeclarationPrice).toString(),
    };
  }
}
